
// export default ForgottenPassword;

// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import './Login.css';
// import './Forgotpassword.css';
// import gox from '../../assets/gox.png';

// function Forgotpassword() {
//   const [passwordVisible, setPasswordVisible] = useState(false);

//   // Toggle password visibility
//   const togglePasswordVisibility = () => {
//     setPasswordVisible(!passwordVisible);
//   };

//   return (
//     <>
//       <div className='banner d-flex'>
//         <div className="left px-5 py-5">
//           <div className='pb-5'> <h6>GOX Register</h6></div>
//           <div>

//             <div className='pt-5 pb-5'>
//               <h1> Where finance <br /> meets management.</h1>
//               <p>Lorem ipsum dolor sit amet consectetur. Lectus nulla sit interdum
//                 et feugiat odio. Lorem ipsum dolor sit amet consectetur. Lectus nulla sit
//                 interdum et feugiat odio.
//               </p>
//             </div>

//             <div className='dynamic p-3'>
//               <p>
//                 In the dynamic landscape of modern workplaces, HR stands as the guardian of culture and the champion of employee well-being. We see our mission as not just managing resources, but as stewards of an environment
//                 where each person's unique skills and perspectives are valued.
//               </p>
//               <div className='d-flex mt-5 '>
//                 <div className='mx-2'><img src={gox} alt="logo" /></div>
//                 <div>
//                   <h6>Gox register</h6>
//                   <p>Our mission</p>
//                 </div>
//               </div>
//             </div>

//           </div>
//         </div>

//         <div>
//                 {/* Right Column with back-button */}
//                 <Link to="/">
//                     <button className="back-button">Back</button>
//                 </Link>
//         </div>

//         <div className="container forms">
//           <div className="">
//             {/* Left Column with H1 and P Tag */}
//             <div className=" welcome col-md-6">
//             <h1>Forgot Password?</h1>
//               <p> Enter the email address you used to sign up, and we'll send
//                     you instructions to reset your password via the email you
//                     provide.
//               </p>
//             </div>
//             {/* Right Column with Form */}
//             <div className="col-md-6">
//               <form>
//                 <div className="mb-3">
//                   <label htmlFor="email" className="form-label"></label>
//                   <input type="email" className="form-control" id="email" placeholder="Enter email" />
//                 </div>

//                 <Link to="/Resetpassword">
//                   <button type="submit" className="btn btn1  w-100,     "  >Submit</button>
//                 </Link>
//               </form>
//               <div className="mt-3">
//                 <p>Need help? <a href="#">Contact Support</a></p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default Forgotpassword;

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import "./ResetPassword.css";
import gox from "../../assets/gox.png";
import { useDispatch } from "react-redux";
import { reset } from "../../action/resetL";

function ForgottenPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState("");
  

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  // useEffect(() => {
  //   dispatch(reset())
  // }, [])

  const handleReset = (e) => {
    e.preventDefault();
    if (email) {
      dispatch(reset(email));
      navigate('/login')
    }
    console.log("reset");
  };

  // forgotten-password-link
  return (
    <>
      {" "}
      <div className="banner d-flex">
        <div className="left px-5 py-5">
          <div className="pb-5">
            {" "}
            <h6>GOX Register</h6>
          </div>
          <div>
            <div className="pt-5 pb-5">
              <h1>
                {" "}
                Where finance <br /> meets management.
              </h1>
              <p>
                Lorem ipsum dolor sit amet consectetur. Lectus nulla sit
                interdum et feugiat odio. Lorem ipsum dolor sit amet
                consectetur. Lectus nulla sit interdum et feugiat odio.
              </p>{" "}
            </div>

            <div className="dynamic p-3">
              <p>
                {" "}
                In the dynamic landscape of modern workplaces, HR stands as the
                guardian of culture and the champion of employee well-being. We
                see our mission as not just managing resources, but as stewards
                of an environment where each person's unique skills and
                perspectives are valued.
              </p>
              <div className="d-flex mt-5 ">
                {" "}
                <div className="mx-2">
                  <img src={gox} alt="logo" />
                </div>
                <div>
                  <h6>Gox register</h6>
                  <p>Our mission</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          {/* Right Column with back-button */}
          <Link to="/login">
            <button className="back-button">Back</button>
          </Link>
        </div>
        <div className="container forms">
          <div className="">
            {/* Left Column with H1 and P Tag */}{" "}
            <div className=" welcome col-md-6">
              <h1>Forgot Password?</h1>{" "}
              <p>
                {" "}
                Enter the email address you used to sign up, and we'll send you
                instructions to reset your password via the email you provide.
              </p>
            </div>
            {/* Right Column with Form */}
            <div className="col-md-6">
              {" "}
              <form onSubmit={handleReset}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label"></label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                {/* <Link to="/Resetpassword"> */}
                <button type="submit" className="btn btn1  w-100     ">
                  Submit
                </button>
                {/* </Link> */}
              </form>
              <div className="mt-3">
                <p>
                  Need help? <a href="#">Contact Support</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgottenPassword;
